export class AzureVmResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "disks",
            "baseName": "disks",
            "type": "Array<InventoryAzureDisk>",
            "format": ""
        },
        {
            "name": "operatingSystem",
            "baseName": "operatingSystem",
            "type": "OperatingSystem",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureVmResource.attributeTypeMap;
    }
    constructor() {
    }
}
